import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { colors } from '@shared/tokens/colors.stylex';

export const styles = stylex.create({
  container: {
    background: colors.deepBackground,
    fontFamily: fonts.din2014Regular,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    ':not(#__unused__) > div > div': {
      width: '500px',
      '@media (max-width: 767px)': {
        width: '100%',
      },
    },
    ':not(#__unused__) div[class*="previewContainer"]': {
      '@media (max-width: 767px)': {
        gap: '32px',
      },
    },
    ':not(#__unused__) textarea[class*="header"]:not([class*="headerTwo"])': {
      '@media (max-width: 767px)': {
        fontSize: '28px',
        lineHeight: '36px',
      },
    },
    ':not(#__unused__) textarea[class*="headerTwo"]': {
      '@media (max-width: 767px)': {
        fontSize: '16px',
        lineHeight: '20px',
      },
    },
    ':not(#__unused__) img': {
      '@media (max-width: 767px)': {
        width: '100%',
        height: '205px',
        objectFit: 'cover',
      },
    },
    ':not(#__unused__) div[class*="text"]': {
      '@media (max-width: 767px)': {
        fontSize: '12px',
        lineHeight: '16px',
      },
    },
    ':not(#__unused__) span[class*="title"]': {
      '@media (max-width: 767px)': {
        fontSize: '16px',
        lineHeight: '20px',
      },
    },
    ':not(#__unused__) label': {
      '@media (max-width: 767px)': {
        fontSize: '16px',
        lineHeight: '20px',
      },
    },
    ':not(#__unused__) div[class*="titleContainer"] span[class*="title"]': {
      '@media (max-width: 767px)': {
        fontSize: '16px',
        lineHeight: '20px',
      },
    },
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
  },
  errorContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
  },
  errorText: {
    fontSize: '18px',
    fontWeight: 600,
    color: palette['grey-950'],
  },
  errorMessage: {
    fontSize: '14px',
    color: palette['grey-600'],
  },
  containerBlack: {
    background: palette['grey-950'],
    fontFamily: fonts.din2014Regular,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: {
      default: '32px 0 0',
      '@media (max-width: 767px)': '32px 16px',
    },
    minHeight: '100vh',
  },
  logoWrapper: {
    width: '129px',
    height: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  errorInviteContent: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: '40px 0',
  },
  errorInviteWrapper: {
    ':not(#__unused__) > div > div > p:first-of-type': {
      color: palette.greyWhite,
    },
    ':not(#__unused__) > div > div > div > p': {
      color: palette['lighted-50'],
    },
  },
});
